export const API = process.env.REACT_APP_BACKEND_URL + '/api';

export function formatDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', year: 'numeric' });
}

export const PLACEMENT_LABELS = {
  home_top: 'Ana Sayfa - Üst',
  home_middle: 'Ana Sayfa - Orta',
  home_bottom: 'Ana Sayfa - Alt',
  forum_top: 'Forum - Üst',
  forum_sidebar: 'Forum - Yan',
  catalog_top: 'Araç Kataloğu - Üst',
  events_top: 'Etkinlikler - Üst',
  topic_top: 'Konu Detay - Üst',
  global_header: 'Tüm Sayfalar - Üst',
  global_footer: 'Tüm Sayfalar - Alt',
};
